import React from 'react';

import { Text, Spacer } from '@zillow/constellation';

const VerifyEmailFailureModal = () => (
    <Spacer marginBottom="sm">
        <Text>
            This account doesn’t match account provided on listing.
            For additional help or questions, please contact customer support.
        </Text>
    </Spacer>
);

export default VerifyEmailFailureModal;
